module.exports = __webpack_public_path__ + "media/ClickOption.200de8e8.mp3";